"use strict";
exports.__esModule = true;
exports.saveUserUUID = exports.getUserUUID = void 0;
var UUID_STORAGE_NAME = 'templateroller-uuid'; // General storage name
var get = function (storageName) {
    try {
        return localStorage.getItem(storageName);
    }
    catch (_a) {
        return null;
    }
};
var save = function (storageName, uuid) {
    try {
        localStorage.setItem(storageName, uuid);
    }
    catch (_a) {
        // ignore errors
    }
};
var getUserUUID = function () { return get(UUID_STORAGE_NAME); };
exports.getUserUUID = getUserUUID;
var saveUserUUID = function (uuid) { return save(UUID_STORAGE_NAME, uuid); };
exports.saveUserUUID = saveUserUUID;
